import { v5 } from "@credijusto/minerals";
import styles from "./MegamenuAboutUs.module.scss";
import LinkArrow from "./icons/LinkArrow";
import articles from "./data.json";

const MegamenuAboutUs = ({ data, slideDown }) => {
  return (
    <div
      className={`${styles.container} bg-mn-secondary-dark-grey py-4 ${
        slideDown ? styles.slideDown : styles.slideUp
      } `}
    >
      <div className="container containerSecond mx-auto hidden xl:flex gap-mn-900 items-start py-0 md:py-4 px-4 md:px-6 lg:px-14">
        {data.columnItems.map((ci) => (
          <div key={ci.id}>
            <v5.Typography
              color="mn-secondary" // Cambiado de text-primary a mn-secondary
              variant="subtitle2"
              font="sans"
              weight="medium"
              className="mb-mn-200"
            >
              {ci.columnName}
            </v5.Typography>
            <ul className="ml-mn-300">
              {ci.links.map((item, itemIndex) => (
                <li key={item.id} className="mb-1">
                  <v5.Typography
                    color="mn-secondary" // Cambiado de text-primary a mn-secondary
                    variant="body2"
                    font="sans"
                    className={styles.links}
                    as="a"
                    href={item.slug}
                  >
                    {item.name}
                  </v5.Typography>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="flex-1 flex flex-col">
          <v5.Typography
            color="mn-secondary" // Cambiado de text-primary a mn-secondary
            variant="subtitle2"
            font="sans"
            weight="medium"
            className="mb-mn-200"
          >
            {data.blogTitle}
          </v5.Typography>
          <ul className="mb-mn-300 ml-mn-300">
            <li className="mb-1">
              <v5.Typography
                color="mn-secondary" // Cambiado de text-primary a mn-secondary
                variant="body2"
                font="sans"
                className={`flex gap-mn-200 items-center ${styles.links}`}
                as="a"
                href="https://covalto.com/blog/"
              >
                Visitar el blog <LinkArrow />
              </v5.Typography>
            </li>
          </ul>
          <div
            className={`flex-1 grid lg:grid-cols-2 xl:grid-cols-3 gap-4 ${styles.articleContainer}`}
          >
            {articles.map((item) => (
              <a
                key={item.strapiId}
                href={`https://covalto.com/blog/${item.slug}/`}
                className={styles.articleCard}
              >
                <div className="flex gap-4 h-full">
                  <div
                    className={styles.articleImage}
                    style={{
                      backgroundImage: `url(${item.images.mobileFeaturedListImage.url})`,
                    }}
                  />
                  <div className="flex flex-1 flex-col gap-mn-200">
                    <v5.Typography
                      color="mn-secondary"
                      variant="body1"
                      font="sans"
                      weight="medium"
                      className={styles.twoLines}
                    >
                      {item.title}
                    </v5.Typography>
                    <v5.Typography
                      color="mn-secondary" // Cambiado de text-primary a mn-secondary
                      variant="body2"
                      font="sans"
                      className={styles.twoLines}
                    >
                      {item.description}
                    </v5.Typography>
                    <div className="flex flex-1 justify-end items-end">
                      <v5.Button
                        as="button"
                        color="mn-secondary"
                        type="button"
                        iconRight={<LinkArrow />}
                        variant="textButton"
                        className={styles.noPadding}
                      >
                        Leer más
                      </v5.Button>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegamenuAboutUs;
